import { ValidatorFn, Validators } from '@angular/forms';

export const US_PHONE_NUMBER_PLACEHOLDER = '(555) 123-4567';

export const US_PHONE_NUMBER_INVALID_MESSAGE =
  'Enter a valid US phone number.';

/**
 * Allowed US phone formats:
 * - (555) 123-4567
 * - 555-123-4567
 * - 555 123 4567
 * - 5551234567
 * - +1 555-123-4567
 * - +1 5551234567
 */
export const US_PHONE_NUMBER_PATTERN =
  /^(\+1\s?)?(?:\(\d{3}\)\s?\d{3}-\d{4}|\d{3}-\d{3}-\d{4}|\d{3}\s\d{3}\s\d{4}|\d{10})$/;

export function getUsPhoneNumberValidators(): ValidatorFn[] {
  return [Validators.pattern(US_PHONE_NUMBER_PATTERN)];
}
